import apiCall from "../AuthorizedApi";

export type C2CConnectionType = "ftps" | "agent";
export type C2CSessionStatus = "active" | "revoked" | "expired";
export type C2CUploadStatus = "success" | "failed" | "duplicate";

export interface C2CAlbum {
  id: number;
  name: string;
}

export interface C2CFolder {
  id: number;
  name: string;
}

export interface C2CDevice {
  id: number;
  name: string;
  brand: string;
  model?: string;
}


export interface C2CUploadStats {
  success: number;
  failed: number;
}

export interface C2CFtps {
  host: string;
  port: number;
  tls: string;
  passive_mode: boolean;
  provider: string;
  username: string;
  password: string; 
}

export interface C2CSession {
  session_id: number;
  status: C2CSessionStatus;
  expires_at: string | null; 
  connection_type: C2CConnectionType;
  staging_prefix: string;
  album: C2CAlbum;
  folder: C2CFolder;
  device: C2CDevice;
  upload_stats: C2CUploadStats;
  ftps?: C2CFtps; 
  credentials_retrievable?: boolean;
}


export interface C2CSessionWithFtps extends C2CSession {
  ftps: C2CFtps; 
}

export interface C2CUploadLog {
  id: number;
  source_filename: string;
  staging_s3_key: string;
  file_size_bytes: number;
  status: C2CUploadStatus;
  error_code: string;
  error_message: string;
  media_id: number | null;
  created_at: string;
}

export interface C2CUploadsResponse {
  count: number;
  page: number;
  page_size: number;
  results: C2CUploadLog[];
}

export interface CreateC2CSessionPayload {
  project_id: number;
  folder_id: number;
  device_name: string;
  device_brand: string;
  device_model: string;
  connection_type: C2CConnectionType;
}


const C2C = "/project/c2c";

export const listC2CSessions = (): Promise<{
  success: boolean;
  data: C2CSession[];
}> => apiCall({ method: "GET", url: `${C2C}/sessions/` });

export const createC2CSession = (
  payload: CreateC2CSessionPayload
): Promise<{
  success: boolean;
  status: number;
  message: string;
  data: C2CSessionWithFtps;
}> => apiCall({ method: "POST", url: `${C2C}/sessions/`, data: payload });

export const getC2CSession = (
  id: number
): Promise<{
  success: boolean;
  data: C2CSession;
}> => apiCall({ method: "GET", url: `${C2C}/sessions/${id}/` });

export const revokeC2CSession = (
  id: number
): Promise<{
  success: boolean;
  status: number;
  message: string;
  data: null;
}> => apiCall({ method: "DELETE", url: `${C2C}/sessions/${id}/` });

export const getC2CUploads = (
  id: number,
  params?: { page?: number; page_size?: number }
): Promise<{
  success: boolean;
  data: C2CUploadsResponse;
}> =>
  apiCall({
    method: "GET",
    url: `${C2C}/sessions/${id}/uploads/`,
    params,
  });

export interface UpdateC2CSessionPayload {
  project_id?: number;
  folder_id?: number;
  device_name?: string;
  device_brand?: string;
  device_model?: string;
}


export const updateC2CSession = (
  id: number,
  payload: UpdateC2CSessionPayload
): Promise<{
  success: boolean;
  status?: number;
  message?: string;
  data: C2CSession;
}> =>
  apiCall({
    method: "PATCH",
    url: `${C2C}/sessions/${id}/`,
    data: payload,
  });

